import {Repository, createRepository} from '@/repositories/Base/Repository'

class ContainerSupportRepository extends Repository {
    endpoint = 'integration/container_support'

    put(params) {
        return this.$axios.put(`${this.endpoint}`, params)
    }
}

export default new ContainerSupportRepository()

export const create = createRepository(ContainerSupportRepository)
